import _ from "lodash";
import {
  IAppointment,
  IAppointmentDetail,
} from "../../types/appointments/Appointment";
import { AppointmentType } from "../../types/appointments/AppointmentType";
import { getGameKey } from "../../util/gamehelper";
import * as types from "../actions/actionTypes";
import { GenericTransport } from "../api/baseApi";
import { IProcessedShiftSessionTransport } from "../api/shiftsApi";
import intialState from "./initialState";
import { IAppointmentState } from "./state";

const getMergedAppointmentsFrom = (
  state: IAppointmentState,
  appointments: IAppointment<IAppointmentDetail>[],
) => {
  if (!appointments) return state;
  const byId = {
    ...state.map,
    ..._.keyBy(appointments, "_id"),
  };

  // I don't care if they're not appointed TBH
  const allAppointments = Object.values(byId);
  const groupedByPerson = _.groupBy(allAppointments, "person");
  const groupedByDateVenueCourt = _.groupBy(
    allAppointments
      .filter((a) => a.type == AppointmentType.game && a.stillAppointed)
      // @ts-ignore
      .map((a) => ({ position: a.details.position, _id: a._id })),
    (aid) => {
      const a = byId[aid._id];
      // @ts-ignore
      return getGameKey(a.start, a.details.venue, a.details.court);
    },
  );

  const byPerson = Object.keys(groupedByPerson).reduce(
    (prev, p) => ({
      ...prev,
      [p]: groupedByPerson[p].map((a) => a._id),
    }),
    {},
  );
  return {
    map: byId,
    byPerson,
    byVenueDateCourt: groupedByDateVenueCourt,
  };
};

const handles = {
  [types.SHIFT_ROSTER_GAME_FULFILLED]: (
    state: IAppointmentState,
    { appointments },
  ) => getMergedAppointmentsFrom(state, appointments),
  [types.SHIFTS_GET_SHIFT_FULFILLED]: (state: IAppointmentState, payload: IProcessedShiftSessionTransport) =>
    getMergedAppointmentsFrom(state, payload.appointments),
  [types.APPOINTMENTS_UPDATE_FULFILLED]: (state: IAppointmentState, payload) =>
    getMergedAppointmentsFrom(state, [payload]),
  [types.SHIFTS_PUBLISH_SESSION_FULFILLED]: (
    state: IAppointmentState,
    { appointments },
  ) => getMergedAppointmentsFrom(state, appointments),
  [types.SHIFTS_ROSTER_SUPERVISOR_FULFILLED]: (
    state: IAppointmentState,
    { appointments },
  ) => getMergedAppointmentsFrom(state, appointments),
  [types.SHIFTS_REMOVE_SUPERVISOR_FULFILLED]: (
    state: IAppointmentState,
    { appointments },
  ) => getMergedAppointmentsFrom(state, appointments),
  [types.SHIFTS_ROSTER_ADMIN_FULFILLED]: (
    state: IAppointmentState,
    { appointments },
  ) => getMergedAppointmentsFrom(state, appointments),
  [types.SHIFTS_REMOVE_ADMIN_FULFILLED]: (
    state: IAppointmentState,
    { appointments },
  ) => getMergedAppointmentsFrom(state, appointments),
  [types.APPOINTMENTS_ADD_LOADING_FULFILLED]: (
    state: IAppointmentState,
    appointment,
  ) => getMergedAppointmentsFrom(state, [appointment]),
  [types.APPOINTMENTS_GET_BY_PERSON_FULFILLED]: (
    state: IAppointmentState,
    data: GenericTransport<IAppointment<IAppointmentDetail>[]>,
  ) => getMergedAppointmentsFrom(state, data.data),
};

export default function appointmentsReducer(
  state = intialState.appointments,
  action,
) {
  return action.type && action.type in handles
    ? handles[action.type](state, action.payload)
    : state;
}
